"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMS = function FlagMS(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.31v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.49V5.12a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.49L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122h-21.18v56.5H-193v21.18h91.81v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.24a7,7,0,0,0-3.37,5.87v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "261.29",
    y: "80.17",
    width: "93.82",
    height: "72.5",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M67.29,29.68c0,24.73,27.72,44.77,46.91,44.77,17.06,0,46.91-20.05,46.91-44.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#c86464"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M126.73-16.35c1.51.27,4.08.62,4.35,4.27S130,4.53,128.68,6.13c0,0,4.36,9.86,4.53,15.73s-.62,23.4-.09,26.21,2.54,8.52,2.54,8.52-6.13-3.59-8.53-1.33-11.2,5.33-14.66,1.74a84.87,84.87,0,0,0,4.13-25.06V-14.31a7.39,7.39,0,0,1,4-1.42c2.26,0,6.13-.62,6.13-.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M127.61,54.11c.27,1.69,1,2.93.63,3.55S125.57,64,126.9,64s3.65-.71,4.27-2,.89-3.1,1.24-3.64-.62-3.2-1.42-3.64a13.22,13.22,0,0,0-3.38-.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#fff5e1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M112.25-12.62l-4.89.63a45.46,45.46,0,0,0,.71-5.42c.09-2.22.27-6.31.27-6.31s3.46-2.14,3.55-2.49c0-.18.45-1.29.13-1.86s-1.38-.63-1.38-.63-4.08,2.13-4.08,2.49a9.5,9.5,0,0,1-.45,3.29c-.44.8-2.93,7.46-3.11,9.24s-.44,5.51.27,5.68,8.09,1,8.89.62.09-5.24.09-5.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#fff5e1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M134.38-30.16H116.6v-8.4h-6.13v8.4H92.68V-24h17.79V56.59h6.13V-24h17.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M123.88-19.28s6,1.71,6.76-.27c.93-2.31-2.18-2.62-2.76-5.06-.06-.27-.62-3.55-3-4.18s-4.62,0-4.71,1.6,3.73,7.91,3.73,7.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#963c3c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M120.69-11.73c-.18,0-.45-1.77-.09-4a5.66,5.66,0,0,0,0-2.93s-2.49.27-2.49-.71.53-5.51,2-7.82a4.06,4.06,0,0,0,3,1.33,3.88,3.88,0,0,0,1,2.67s-1.33,1.15-.71,2a14.33,14.33,0,0,0,1.78,1.78,4.77,4.77,0,0,0,1.51,3.11,8.67,8.67,0,0,1-6,4.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#fff5e1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "290.34",
    y: "149.84",
    width: "0.53",
    height: "10.57",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "292.49",
    y: "147.79",
    width: "0.53",
    height: "14.66",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "294.63",
    y: "145.91",
    width: "0.53",
    height: "18.41",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "296.78",
    y: "143.23",
    width: "0.53",
    height: "23.75",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "298.92",
    y: "139.74",
    width: "0.53",
    height: "30.74",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "301.06",
    y: "139.74",
    width: "0.54",
    height: "32.18",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M116.69,33.58c-2.36-12.25-8.89-19.37-11.2-19.72a3.72,3.72,0,0,0-4.17,2.84c-.18,1.33-1.43,5.34-4,7.2S90,26.83,88.88,30.3s1.78,5,3.46,4.61a2.72,2.72,0,0,0,.38-.11l18.16,22.34a1.44,1.44,0,0,0,2.41-.26c1.86-3.82,5.4-12.85,3.4-23.3Zm-22.44.25a2.16,2.16,0,0,0,.23-2.91c-1.34-1.87-2.85.8-2.85.8s-.44-2.31,3-3.47S102,25.14,103.8,21s1.69-3.38,1.69-3.38,7.11,4,8.09,16.53-2.49,17.59-2.49,17.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110.47,6.78c-.82.52-1.55,1-2.07,1.24-1.66.86-3.66,1.73-3.86,2.53S103.21,12,103.27,13s0,3.73,0,3.73c1-.2,3-.54,3.67-1.74s1.26-3.53,3.4-4.53l.13-.05Zm0,0",
    transform: "translate(194 123)",
    fill: "#fff5e1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M128.12-10.24a15.47,15.47,0,0,0-4.46,5.73c-.47,1.67-1.93,5.6-1.93,5.6a16.77,16.77,0,0,0-5.13,1.57V8.48a16.89,16.89,0,0,0,2.8-1c1.73-.94,4.2-2.67,5.46-3S127.19,2,127.66.76a33.58,33.58,0,0,0,2.13-7.53c.2-2.54-.67-3.94-1.67-3.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#fff5e1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.2,76l-.23,0C66.34,68.41,65.8,27.16,65.8,25.41V-44.32h96.81V25.41c0,1.75-.55,43-48.18,50.52ZM68.78-41.33V25.41c0,1.64.52,40.31,45.42,47.53,44.9-7.22,45.42-45.89,45.42-47.53V-41.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMS;
exports["default"] = _default;